import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { callHistoryQueryKeys } from './queryKeys';

const getRingList = async (data) => {
  return await request.get(
    `/Phone/get_ring_list`,
    data,
    'При загрузке списка звонков произошла ошибка',
    { result: 'Error' }
  );
};

const useRingList = (queries, options) => {
  return useQuery(
    callHistoryQueryKeys.ringList(queries),
    () => getRingList(queries),
    options
  );
};

export default useRingList;
